// i18n bundle plumbing. Phase 1 will add real LT/EN message catalogs; for
// Phase 0 we ship just the bundle map and a `t()` lookup so callers compile.
import lt from './lt.json' with { type: 'json' };
import en from './en.json' with { type: 'json' };
import { DEFAULT_LOCALE } from '../domain/locales.js';
export const BUNDLES = { lt, en };
export function t(key, locale = DEFAULT_LOCALE) {
    return BUNDLES[locale]?.[key] ?? BUNDLES[DEFAULT_LOCALE]?.[key] ?? key;
}
//# sourceMappingURL=index.js.map